// extracted by mini-css-extract-plugin
module.exports = {"row":"Row-module__row--2WzZo","text":"Row-module__text--fnntd"};